// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "d26c534759182e5063f7e208dd43fd8e3879aa5b/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};